if(window.Shopify?.country !== 'US' && !localStorage.getItem('countryChangeExecuted')){
    function globalECountryChangeForce(){
      fetch("/localization", {
          method: 'PUT',
            headers: {
              'Content-Type': 'application/json'
            },
            body: JSON.stringify({
              return_to: window.Shopify?.routes?.root?.replace(/\/$/, ''),
              country_code: window.Shopify?.country,
              currency_code: window.Shopify?.currency?.active
            })
      }).then(() => {
        localStorage.setItem('countryChangeExecuted', 'true');
      }).catch((error) => {
        console.error('Country change request failed:', error);
      });
    }
    document.addEventListener('DOMContentLoaded', function() {
      setTimeout(() => {
        globalECountryChangeForce();
      }, 1500);
    });
  } 